import { RichText } from '@atlassiansox/bxp-content-framework';
import styled from 'styled-components';
import { colorCSS } from '../../../../styles';
export const Button = styled.button `
  align-items: center;
  background-color: ${colorCSS('N20')};
  border: 1px solid ${colorCSS('N60')};
  border-radius: 8px;
  display: flex;
  margin-bottom: 2rem;
  padding: 4px;
  padding-right: 8px;
  transition: all 250ms ease-out;
  &:focus,
  &:active {
    box-shadow: 0 0 0 0.2rem ${colorCSS('N40')};
  }
  > svg {
    width: 24px;
    height: auto;
    margin: 4px;
  }
`;
export const ButtonText = styled(RichText) `
  margin: 4px;
  p:last-of-type {
    margin-bottom: 0;
  }
`;
//# sourceMappingURL=AddToSlackButton.styles.js.map